import { TenantRoles } from 'modules/application/tenant/TenantService';
import { CreateApplicationSteps } from 'modules/application/create/CreateApplicationService';
import { initialSetupMembersStateName } from 'modules/initialSetup';
import { INITIAL_SETUP_CHATBOT_CREATE, INITIAL_SETUP_CHATBOT_EDIT, INITIAL_SETUP_CHATBOT_EDIT_SAVE, INITIAL_SETUP_CHATBOT_IMAGE_UPLOAD, INITIAL_SETUP_CHATBOT_SELECT_OPTION, INITIAL_SETUP_CHATBOT_SKIP, } from 'modules/initialSetup/initialSetupSegmentEvents';
import './applicationStep.scss';
export class ApplicationStepController {
    static $inject = ['$translate', 'TenantService', 'ContextProcessorService', 'CreateApplicationService', 'AccountService2', 'ApplicationService2', 'BlipToastService', 'SegmentService', 'LoadingService', '$rootScope', '$state', 'BLIP_DOMAIN'];
    constructor($translate, TenantService, ContextProcessorService, CreateApplicationService, AccountService2, ApplicationService2, BlipToastService, SegmentService, LoadingService, $rootScope, $state, BLIP_DOMAIN) {
        'ngInject';
        this.$translate = $translate;
        this.TenantService = TenantService;
        this.ContextProcessorService = ContextProcessorService;
        this.CreateApplicationService = CreateApplicationService;
        this.AccountService2 = AccountService2;
        this.ApplicationService2 = ApplicationService2;
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.LoadingService = LoadingService;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.isEditing = false;
        this.isCreating = false;
        this.applicationCreated = true;
        this.selectedTemplate = 'blip_deskCustomerService';
        this.setupFileUploader = () => {
            this.avatarUploader = () => document
                .querySelector('#avatar-uploader')
                .shadowRoot
                .querySelector('.upload__input');
            document
                .querySelector('#avatar-uploader')
                .addEventListener('bdsUploadChange', (e) => {
                this.applicationImage = e.detail.value[0];
                this.applicationImageUri = URL.createObjectURL(this.applicationImage);
                this.SegmentService.createOrganizationTrack(INITIAL_SETUP_CHATBOT_IMAGE_UPLOAD);
                this.$rootScope.$apply();
            });
        };
        this.toggleApplicationEditor = () => {
            if (this.isEditing) {
                this.SegmentService.createOrganizationTrack(INITIAL_SETUP_CHATBOT_EDIT_SAVE);
            }
            else {
                this.SegmentService.createOrganizationTrack(INITIAL_SETUP_CHATBOT_EDIT);
            }
            this.isEditing = !this.isEditing;
        };
        this.onChangeApplicationName = (event) => {
            this.applicationName = event.detail.value ?? '';
        };
        this.setTemplate = (template) => {
            this.selectedTemplate = template;
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_CHATBOT_SELECT_OPTION, {
                optionName: template,
            });
        };
        this.isApplicationNameValid = () => {
            const letterFirstPosition = /(^[a-zA-Z])/;
            return (this.applicationName &&
                this.applicationName.length >= 2 &&
                this.applicationName.length <= 30 &&
                !!letterFirstPosition.exec(this.applicationName));
        };
        this.createApplication = async () => {
            if (this.isCreating) {
                return;
            }
            this.isCreating = true;
            this.LoadingService.startLoading(false);
            let application = {
                name: this.applicationName,
                imageUri: this.applicationImage ? undefined : this.applicationImageUri,
                image: this.applicationImage,
            };
            try {
                application = await this.CreateApplicationService.createApplication(application, this.selectedTemplate);
                this.trackApplicationCreation(application);
                this.goToNextStep();
            }
            catch (err) {
                const errStep = err.step;
                // If not essential for chatbot works, continue
                if (errStep != CreateApplicationSteps.BuilderActivation &&
                    errStep != CreateApplicationSteps.DataValidation &&
                    errStep != CreateApplicationSteps.InitialCreation) {
                    this.trackApplicationCreation(application);
                    this.goToNextStep();
                    return;
                }
                const errorTitle = await this.$translate('createApplication.errorMsg.title');
                let errorMessage;
                switch (errStep) {
                    case CreateApplicationSteps.DataValidation:
                        errorMessage = await this.$translate('createApplication.errorMsg.2');
                        break;
                    default:
                        errorMessage = await this.$translate('createApplication.errorMsg.1');
                        break;
                }
                this.BlipToastService.show('danger', {
                    title: errorTitle,
                    msg: errorMessage,
                });
            }
            finally {
                this.isCreating = false;
                this.LoadingService.stopLoading();
            }
        };
        this.skipApplicationCreation = async () => {
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_CHATBOT_SKIP);
            this.applicationCreated = false;
            this.goToNextStep();
        };
    }
    async $onInit() {
        this.setupFileUploader();
        await this.ContextProcessorService.waitForInitialization();
        const me = await this.AccountService2.me();
        const applications = await this.ApplicationService2.getApplications(this.ContextProcessorService.tenant.id);
        const hasPermission = await this.TenantService.hasRequiredTenantRole(`${encodeURIComponent(me.email)}@${this.BLIP_DOMAIN}`, this.ContextProcessorService.tenant.id, [TenantRoles.Admin, TenantRoles.Member]);
        if (!hasPermission || applications.length > 0) {
            this.goToNextStep();
            return;
        }
        const namePrefix = await this.$translate('initialSetup.application.chatbot.namePrefix');
        this.tenant = await this.TenantService.get(this.ContextProcessorService.tenant.id);
        this.applicationImageUri = this.tenant.photoUri;
        this.applicationName = `${namePrefix} ${this.tenant.name}`.length > 30 ?
            this.tenant.name.substring(0, 29) :
            `${namePrefix} ${this.tenant.name}`;
    }
    trackApplicationCreation(application) {
        this.SegmentService.createApplicationTrack({
            trackEvent: INITIAL_SETUP_CHATBOT_CREATE,
            application,
            payload: {
                optionSelected: this.selectedTemplate,
            },
        });
    }
    async goToNextStep() {
        this.$rootScope.initialSetupApplicationCreated = this.applicationCreated;
        this.$state.go(initialSetupMembersStateName);
    }
}
ApplicationStepController.$inject = ['$translate', 'TenantService', 'ContextProcessorService', 'CreateApplicationService', 'AccountService2', 'ApplicationService2', 'BlipToastService', 'SegmentService', 'LoadingService', '$rootScope', '$state', 'BLIP_DOMAIN'];
